import "./trans";

window.showAppInstruction = (string) => {
  switch (string) {
    case "ios":
      $(".modal-popup").removeClass("android").addClass("ios");
      break;
    case "android":
      $(".modal-popup").removeClass("ios").addClass("android");
      break;
    default:
      $(".popup_app_inst").show();
  }
};

window.hideAppInstruction = () => {
  $(".popup_app_inst").hide();
  $(".back_body1").hide();
};

$(function () {
  // close button
  $(".close-btn").click(function (e) {
    e.preventDefault();
    $(this).parent(".right-sidebar").fadeOut();
  });
});

// Banner carousel
if (Pace) {
  Pace.on("done", initBanner);
} else {
  $(window).load(initBanner);
}

function initBanner() {
  initSwiper();
}

function initSwiper() {
  const bannerList = window.banner;
  const indexContainer = $(".swiper-wrapper");
  const isLoggedIn = $(".before-login.hide").length !== 0;

  bannerList &&
    bannerList !== 0 &&
    bannerList.forEach(function (item) {
      const { imageUrl, redirectUrl, redirectGroup, redirectPage, bannerType } = item;

      if (imageUrl) {
        /**
         * Redirect Group Option
         * 0 - Promo
         * 1 - Join Us
         * 2 - Lottery
         * 3 - Product
         * 4 - Others inner page (Loyalty, Customer Service)
         * 5 - 自定义
         */
        const banner = $(`
      <div class="swiper-slide">
        <img ${redirectUrl ? `data-redirect=${redirectUrl}` : ""} class="img" src="${imageUrl}"/>
        <div class="img-bg" style="background-image: url(${imageUrl})"></div>
      </div>
    `);

        banner.click(() =>
          window.initBannerCarouselRedirection({
            redirectUrl,
            redirectGroup,
            redirectPage,
            isLoggedIn,
          })
        );

        /**
         * index append 首页type banner, xycly promo.html no banner
         * 轮播图类型 bannerType
         * 0 - 首页
         * 1 - 优惠活动
         * 2 - 其他
         */
        if (bannerType === 0) {
          indexContainer.append(banner);
        }
      }
    });
  if (bannerList && bannerList.length) {
    new Swiper(".swiper-container", {
      speed: 400,
      spaceBetween: 10,
      autoplay: {
        delay: 5000,
      },
      loop: true,
    });
  }
}

//Load trans
$(function () {
  var transactionsContainer = $("#transactionsContainer");
  transactionsContainer.children().remove();
  if (!!transactionsContainer.length) {
    api.getTrans(function (response) {
      response.data.result.forEach(function (info, i) {
        // console.log(info);
        transactionsContainer.append(
          $(
            `<div class="info${i == 0 ? " active" : ""}">
              恭喜会员 ${info.username} 提款 ${-info.amount} 元成功，请及时查看银行卡账目。
            </div>`
          )
        );
      });
      window.transInit();
    });
  }
});

// Date timer
$(function () {
  setInterval(updateTime, 1000);

  function updateTime() {
    var date = new Date().toLocaleString("en-US", { hour12: false }).split(" ");
    var time = date[1];
    var mdy = date[0];
    mdy = mdy.split("/");
    var month = parseInt(mdy[0]);
    var day = parseInt(mdy[1]);
    var year = parseInt(mdy[2]);
    var formattedDate = year + "-" + month + "-" + day + " " + time;

    $(".top .showTime").text(formattedDate);
  }
  updateTime();
});

// Bookmarks
$(function () {
  var a = $(".quicklinks .bookmark");
  a.click(function () {
    if (window.sidebar && window.sidebar.addPanel) {
      window.sidebar.addPanel(document.title, window.location.href, "");
    } else {
      if (window.external && "AddFavorite" in window.external) {
        window.external.AddFavorite(location.href, document.title);
      } else {
        if ((window.opera && window.print) || (window.sidebar && !(window.sidebar instanceof Node))) {
          a.attr("rel", "sidebar").attr("title", document.title).attr("href", window.location.href);
          return true;
        } else {
          alert(
            "You can add this page to your bookmarks by pressing " +
              (navigator.userAgent.toLowerCase().indexOf("mac") != -1 ? "Command/Cmd" : "CTRL") +
              " + D on your keyboard."
          );
        }
      }
    }
    return false;
  });
});

// promotion
$(function () {
  if (window.promo) {
    renderPromo(window.promo);
  } else {
    Object.defineProperty(window, "promo", {
      set: function (data) {
        renderPromo(data);
      },
    });
  }

  function registerPromo(promoId) {
    api.registerPromo(promoId);
  }

  function renderPromo(promoData) {
    if (Array.isArray(promoData)) {
      var promoWrapper = $(".promo-wrapper");
      promoData.forEach(function (value, index) {
        var promoItem = $(`<div class="main_box" data-type="${value.type}"></div>`);
        var promoId = value.promoId;
        var requestToJoin = value.requestToJoin;
        var firstDepositPromoJoinMsg = value.firstDepositPromoJoinMsg;

        var promoId = value.promoId;
        var requestToJoin = value.requestToJoin;
        var firstDepositPromoJoinMsg = value.firstDepositPromoJoinMsg;

        promoItem.append(
          $(`
              ${
                value.imagePath
                  ? `
                  <div class="icon sub-content-item-header">
                    <img src="${value.imagePath}" />
                  </div>
                `
                  : `
                  <div class="sub-content-item-header">
                    <h3>${value.title}</h3>
                  </div>
                `
              }
              <div class="text nr" style="display: none;">
                  ${value.content}
                  ${
                    requestToJoin
                      ? `
                             <div
                               class="sub-content-item-footer"
                               style="display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; height: 50px;"
                             >
                               ${
                                 firstDepositPromoJoinMsg
                                   ? `
                                     <div class="sub-content-item-footer--info" style="color: #555;">
                                       ${firstDepositPromoJoinMsg}
                                     </div>
                                   `
                                   : `
                                     <button
                                       class="sub-content-item-footer--register-promo"
                                       data-id="${promoId}"
                                       style="background-image: linear-gradient(to right, #e8d154 0%, #fdf5ae 50%, #efd061 100%);cursor:pointer;color:#1b191a;outline: 0;border:0;height: 35px; width: 110px;"
                                     >
                                       申请参与
                                     </button>
                                   `
                               }
                             </div>
                           `
                      : ``
                  }
              </div>
            `)
        );
        promoWrapper.append(promoItem);
      });

      $(".sub-content-item-footer--register-promo").on("click", function (e) {
        e.preventDefault();
        var promoId = $(this).data("id");
        registerPromo(promoId);
      });

      $(document).on("click", ".main_box .sub-content-item-header", function (e) {
        e.preventDefault();
        var mainbox = $(this).closest(".main_box");
        if (mainbox.hasClass("on")) {
          mainbox.removeClass("on");
          mainbox.children(".bt").show();
          mainbox.children(".nr").slideUp();
        } else {
          mainbox.addClass("on");
          mainbox.children(".bt").hide();
          mainbox.children(".nr").slideDown();
        }
      });
    }
  }
});

// old promo without slide down
// $(function() {
//   if (window.promo) {
//     renderPromo(window.promo);
//   } else {
//     Object.defineProperty(window, "promo", {
//       set: function(data) {
//         renderPromo(data);
//       }
//     });
//   }
//
//   function renderPromo(promoData) {
//     if (Array.isArray(promoData)) {
//       var promoWrapper = $("#promotionWrapper");
//       promoData.forEach(function(value, index) {
//         var promoItem = $(`<li data-type="${value.type}"></li>`);
//
//         promoItem.append(
//           $(
//             `
//             <div class="top">${value.title}</div>
//             <div class="mid">
//               <ul>
//                 <li class="subtitle"></li>
//                 ${
//                   value.imagePath
//                     ? `
//                   <li>
//                     <img src="${value.imagePath}" style="width: 100%;"/>
//                   </li>
//                 `
//                     : ""
//                 }
//                 <li>${value.content}</li>
//               </ul>
//             </div>
//             `
//           )
//         );
//         promoWrapper.append(promoItem);
//       });
//
//       $(".promo-box .sub-content-item-header").click(function(e) {
//         e.preventDefault();
//         $(this)
//           .siblings(".sub-content-item-content")
//           .slideToggle();
//       });
//     }
//   }
// });

// Notice

$(function () {
  $(".marquee").click(function () {
    api.getNotice(function (res) {
      var list = res.data.result;
      var wrapper;
      if ($("#noticeWrapper").length) {
        wrapper = $("#noticeWrapper");
        wrapper.html("");
        wrapper.show();
      } else {
        wrapper = $(`<div id='noticeWrapper'></div>`);
      }

      var content = $(`<div class='notice-content'></div>`);
      var closeBtn = $(`<div class="close"></div>`);
      closeBtn.click(function () {
        $(this).parents("#noticeWrapper").fadeOut();
      });
      wrapper.append(content);
      content.append(closeBtn);
      content.append(`<h3>公告</h3>`);
      var tableWrapper = $(`<div class="table-wrapper"></div>`);
      content.append(tableWrapper);
      var table = $(`<table class="notice-table"></table>`);
      tableWrapper.append(table);

      table.append(`
        <tr>
          <th>时间</th>
          <th>公告详情</th>
        </tr>
      `);
      list.forEach(function (item, i) {
        var item = $(`
          <tr>
            <td class="notice-date">
              ${new Date(item.created).toLocaleString("zh-en", { hour12: false }).replace(/\//g, "-")}
            </td>
            <td>${item.text}</td>
          <tr>
        `);
        table.append(item);
      });

      $("body").append(wrapper);
    });
  });
});

//
$(function () {
  $(".subcontent-nav li a:not(.special)").click(function (e) {
    var currentSubcontentIndex = $(this).parent("li").index();
    var currentChildIndex = 1;
    $(this).addClass("active");
    $(".subcontent-nav li a").not($(this)).removeClass("active");
    e.preventDefault();
    currentChildIndex = currentSubcontentIndex + 1;
    $(".sub-contents:nth-child(" + currentChildIndex + ")").show();
    $(".sub-contents:not(:nth-child(" + currentChildIndex + "))").hide();
  });
});
